/**
 * 菜单配置 API
 */
import {
  $get, $post, $delete,
} from '@/utils/request';
import servers from '@/api/servers';
import type { MenuConfigFile, MenuBackupItem } from '@/types/menu';

/**
 * 获取菜单配置
 * @param appCode 应用编码，不传则使用当前租户的应用编码
 */
export const getMenuConfig = (
  appCode?: string
): Promise<ResponseData<MenuConfigFile>> => $get(
  `${servers.base}/api/v1/menu/getList`,
  {
    params: { appCode },
  }
);

/**
 * 保存菜单配置
 * @param data 菜单配置数据
 */
export const saveMenuConfig = (
  data: MenuConfigFile
): Promise<{ code: number; message: string }> => $post(
  `${servers.base}/api/v1/menu/config`,
  data
);

/**
 * 获取版本历史列表
 * @param appCode 应用编码
 */
export const getBackupList = (
  appCode?: string
): Promise<ResponseData<MenuBackupItem[]>> => $get(
  `${servers.base}/api/v1/menu/backup/list`,
  {
    params: { appCode },
  }
);

/**
 * 删除备份文件
 * @param appCode 应用编码
 * @param fileName 文件名
 */
export const deleteBackup = (
  appCode: string,
  fileName: string
): Promise<{ code: number; message: string }> => $delete(
  `${servers.base}/api/v1/menu/backup/delete`,
  {
    params: { appCode, fileName },
  }
);
